import { render } from "./TransformModuleProperties.vue?vue&type=template&id=d0321600&scoped=true"
import script from "./TransformModuleProperties.vue?vue&type=script&lang=js"
export * from "./TransformModuleProperties.vue?vue&type=script&lang=js"

import "./TransformModuleProperties.vue?vue&type=style&index=0&id=d0321600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0321600"]])

export default __exports__